import { render, staticRenderFns } from "./EmptyImg.vue?vue&type=template&id=63640d6a"
import script from "./EmptyImg.vue?vue&type=script&lang=js"
export * from "./EmptyImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports